import { useState } from "react";
import AdorLogo from "../../asset/images/header/powertrone-logo.png";
import CallIcon from "../../asset/images/header/Call.svg";
import MailIcon from "../../asset/images/header/Mail.svg";
import LinkedInIcon from "../../asset/images/header/LinkedIn.svg";
import YouTubeIcon from "../../asset/images/header/YouTube.svg";
import GridIcon from "../../asset/images/header/Grid.svg";

const DARK = "#202020";

const NAV_LINKS = [
  { label: "Home",               path: "/",             dropdown: false },
  { label: "About Us",           path: "/about-us",     dropdown: true  },
  { label: "Our Business",       path: "", dropdown: true  },
  { label: "E-Waste Management", path: "/e-waste-management",      dropdown: false },
  { label: "News & Updates",     path: "/news",         dropdown: false },
];

const DROPDOWNS = {
  "About Us": [
    { label: "Ador Clean Air", path: "/about-us"     },
    { label: "Credentials",    path: "/credentials"  },
    { label: "Life@Ador",      path: "/life-at-ador" },
    { label: "Core Values",    path: "/core-values"  },
    { label: "Leadership",     path: "/our-team"     },
    { label: "Career",         path: "/careers"      },
  ],
  "Our Business": [
    { label: "Clean Air",            path: "/products"                              },
    { label: "Power & Surveillance", path: "/power-surveillance/hp-series" },
    { label: "Software Innovation",  path: "/software-innovation"                   },
    {
      label: "Defence",
      children: [
        { label: "Ador Defence", path: "/defence/ador-defence" },
        { label: "Products", path: "/defence/products" },
      ],
    },
  ],
};

/* Grid popup links */
const GRID_LINKS = [
  { label: "Ador India",       path: "https://adorindia.com/",       active: false },
  { label: "Ador Traffic",     path: "https://adortraffic.com/",     active: false },
  { label: "Ador Digatron",    path: "https://adordigatron.com/",    active: false },
  { label: "Energizing India", path: "https://energizingindia.tv/", active: false },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=DM+Sans:wght@500;600;700&display=swap');

  .ah-wrap *, .ah-wrap *::before, .ah-wrap *::after {
    box-sizing: border-box; margin: 0; padding: 0;
  }
  .ah-wrap {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    position: sticky;
    top: 0;
    z-index: 999;
  }

  /* TOP BAR */
  .ah-top { background: #202020; width: 100%; }
  .ah-top-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    height: 104px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  .ah-logo { display: inline-flex; align-items: center; text-decoration: none; flex-shrink: 0; }
  .ah-logo-img { height: 64px; width: 114px; object-fit: contain; display: block; }

  .ah-search {
    display: flex;
    align-items: center;
    background: #202020;
    border: 1px solid #8C8C8C;
    border-radius: 10px;
    padding: 10px 12px;
    gap: 14px;
    width: 277px;
    flex-shrink: 0;
  }
  .ah-search input {
    background: transparent;
    border: none;
    outline: none;
    color: #FFFFFF;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    width: 100%;
  }
  .ah-search input::placeholder { color: #FFFFFF; }

  .ah-top-right { display: flex; align-items: center; gap: 24px; }

  .ah-contact-link {
    display: flex;
    align-items: center;
    gap: 14px;
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.15s;
    margin-left: 15px;
  }
  .ah-contact-link:hover { color: #ffffff; }
  .ah-contact-icon { width: 20px; height: 20px; display: block; flex-shrink: 0; }

  .ah-cta-btn {
    background: #EB2019;
    color: #ffffff;
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    border: none;
    border-radius: 10px;
    padding: 14px 36px;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    transition: background 0.18s;
    flex-shrink: 0;
    margin-left: 20px;
  }
  .ah-cta-btn:hover { background: #c9181d; }

  /* NAV BAR */
  .ah-nav-bar { background: #ffffff; width: 100%; border-top: 1px solid #eeeeee; }
  .ah-nav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    height: 57px;
    display: flex;
    align-items: stretch;
    justify-content: end;
  }
  .ah-nav-links {
    display: flex;
    align-items: stretch;
    list-style: none;
    margin-right: 248px;
  }
  .ah-nav-item { display: flex; align-items: stretch; position: relative; }
  .ah-nav-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    background: none;
    border: none;
    transition: color 0.15s;
  }
  .ah-nav-link:hover { color: #EB2019; }
  .ah-nav-link.active { background: #EB2019; padding: 20px; color: #ffffff !important; }

  /* DROPDOWN — your customization preserved exactly */
  .ah-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 313px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 1000;
    padding: 0px 9px;
    animation: ahDropIn 160ms ease forwards;
  }
  @keyframes ahDropIn {
    from { opacity: 0; transform: translateY(-5px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .ah-dropdown-item {
    display: block;
    padding: 14px 15px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #D3D3D3;
    transition: color 0.14s, background 0.14s;
  }
  .ah-dropdown-item:last-child { border-bottom: none; }
  .ah-dropdown-item:hover { color: #EB2019; }
  .ah-dropdown-item.ah-dd-active { color: #B91E1A; font-weight: 500; }

  /* Nested dropdown: Defence -> products */
  .ah-dd-parent { position: relative; }

  .ah-dd-has-sub {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 15px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 1px solid #D3D3D3;
    cursor: default;
    user-select: none;
    transition: color 0.14s;
  }
  .ah-dd-parent:hover > .ah-dd-has-sub { color: #EB2019; }

  .ah-dd-sub { display: none; background: #FAFAFA; }
  .ah-dd-parent:hover .ah-dd-sub { display: block; }

  .ah-dd-sub-item {
    display: block;
    padding: 13px 15px 13px 30px;
    font-family: 'Poppins', sans-serif;
    font-size: 13.5px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #D3D3D3;
    transition: color 0.14s, background 0.14s;
  }
  .ah-dd-sub-item:hover { color: #EB2019;  }
  .ah-dd-sub-item.ah-dd-active { color: #B91E1A; font-weight: 500; }

  /* Social */
  .ah-social { display: flex; align-items: center; gap: 20px; }
  .ah-social-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 20px;
    background: #1c1c1c;
    text-decoration: none;
    transition: background 0.18s;
    flex-shrink: 0;
  }
  .ah-social-icon:hover { background: none; }
  .ah-social-icon.grid { background: transparent; cursor: pointer; border: none; }
  .ah-social-icon.grid:hover { background: none; }

  .ah-chevron { width: 11px; height: 11px; display: inline-block; flex-shrink: 0; transition: transform 0.2s ease; }
  .ah-chevron.open { transform: rotate(180deg); }
  .ah-dd-parent:hover .ah-chevron { transform: rotate(180deg); }

  /* Hamburger — hidden, grid icon handles mobile menu */
  .ah-hamburger {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
  }
  .ah-hamburger span {
    display: block;
    width: 20px;
    height: 2px;
    background: #ffffff;
    border-radius: 2px;
    transition: all 0.22s;
  }

  /* Mobile Drawer */
  .ah-drawer {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 1000;
    overflow-y: auto;
  }
  .ah-drawer.open { display: block; }
  .ah-drawer-inner { padding: 0 20px 24px; }
  .ah-drawer-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 40px;
    border-bottom: 0.7px solid #B8B8B8 !important;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: ${DARK};
    font-family: 'Poppins', sans-serif;
    text-decoration: none;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    transition: color 0.15s;
  }
     .ah-drawer-row1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 40px;
    border-bottom: 0.7px solid #B8B8B8 !important;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: ${DARK};
    font-family: 'Poppins', sans-serif;
    text-decoration: none;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    transition: color 0.15s;
  }
    .ah-drawer-row1:hover { color: #EB2019; }
  .ah-drawer-row:hover { color: #EB2019; }
  .ah-drawer-chevron { transition: transform 0.2s; flex-shrink: 0; }
  .ah-drawer-chevron.open { transform: rotate(180deg); }
  .ah-drawer-sub {
    display: flex;
    flex-direction: column;
    padding: 4px 0 8px 0px;
    gap: 2px;
    border-bottom: 1px solid #f3f3f3;
  }
  .ah-drawer-sub-link {
    display: block;
    padding: 12px 66px;
    font-size: 14px;
    font-weight: 300;
    color: #000000;
     border-bottom: 0.7px solid #B8B8B8;
    text-decoration: none;
   
    font-family: 'Poppins', sans-serif;
    transition: color 0.14s, background 0.14s;
  }
  .ah-drawer-sub-link:hover { color: #EB2019; background: #FFF5F5; }
  .ah-drawer-sub-parent { font-weight: 500; cursor: default; }
  .ah-drawer-sub-child  { padding: 12px 66px 12px 90px; }
  .ah-drawer-cta {
    display: block;
    margin-top: 20px;
    text-align: center;
    background: #EB2019;
    color: #fff;
    padding: 13px 0;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none;
    transition: opacity 0.18s;
  }
  .ah-drawer-cta:hover { opacity: 0.87; }

  /* Mobile drawer — new header row */
  .ah-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #202020;
    padding: 14px 20px;
    gap: 12px;
    margin: 0 -20px;
  }
  .ah-drawer-header-logo { height: 44px; width: auto; object-fit: contain; display: block; }
  .ah-drawer-header-right { display: flex; align-items: center; gap: 12px; }
  .ah-drawer-contact-btn {
    background: #EB2019;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }
  .ah-drawer-close-btn {
    background: none;
    border: none;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
  }

  /* Ador sub-links */
  .ah-drawer-sub-link-active { color: #EB2019 !important; }

  /* Mobile drawer bottom social row */
  .ah-drawer-socials {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 15px 0 4px 0;
    border-top: 1px solid #f3f3f3;
    
  }
  .ah-drawer-social-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
   
    text-decoration: none;
    flex-shrink: 0;
  }
  .ah-drawer-social-icon img { width: 28px; height: 28px; display: block; }

  /* RESPONSIVE — mobile: logo left, Contact Us center, hamburger right */
  @media (max-width: 900px) {
    .ah-top-inner    { padding: 0 20px; height: 72px; }
    .ah-search       { display: none; }
    .ah-contact-link { display: none; }
    .ah-cta-btn      { display: inline-flex; margin-left: 0; padding: 12px 28px; font-size: 14px; border-radius: 8px; }
    .ah-hamburger    { display: flex; }
    .ah-nav-bar      { display: none; }
    .ah-logo-img     { height: 44px; width: auto; }
    .ah-drawer-cta   { display: none; }
  }

  /* ══════════════════════════════════════════
     GRID POPUP — full screen centered overlay
  ══════════════════════════════════════════ */
  .ah-grid-overlay {
    display: none;
    position: fixed;
    inset: 0;
    z-index: 1100;
   background: rgba(0, 0, 0, 0.8);
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .ah-grid-overlay.open { display: flex; }

  .ah-grid-links {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  .ah-grid-link {
    display: block;
    padding: 14px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    font-weight: 300;
    color: #ffffff;
    text-decoration: none;
    text-align: center;
    transition: color 0.15s;
  }
  .ah-grid-link:hover { color: #EB2019; }
  .ah-grid-link.ah-grid-active { color: #EB2019; }

  /* × close button — below links, centered */
  .ah-grid-close {
    margin-top: 30px;
    background: none;
    border: none;
    color: #fff;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
    padding: 10px;
    opacity: 0.75;
    transition: opacity 0.15s;
    display: block;
  }
  .ah-grid-close:hover { opacity: 1; }
`;

const ChevronDown = ({ open }) => (
  <svg className={`ah-chevron${open ? " open" : ""}`} viewBox="0 0 12 12" fill="none">
    <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const isActive = (path) => {
  if (!path) return false;
  if (path === "/") return window.location.pathname === "/";
  return window.location.pathname.startsWith(path);
};

export default function AdorHeader() {
  const [mobileOpen, setMobileOpen]         = useState(false);
  const [openDropdown, setOpenDropdown]     = useState(null);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [gridOpen, setGridOpen]             = useState(false);

  const closeAll = () => {
    setMobileOpen(false);
    setOpenDropdown(null);
    setMobileExpanded(null);
  };

  return (
    <>
      <style>{CSS}</style>

      <div className="ah-wrap">

        {/* TOP BAR */}
        <div className="ah-top">
          <div className="ah-top-inner">
            <a href="/" className="ah-logo">
              <img src={AdorLogo} alt="Ador Powertron" className="ah-logo-img" />
            </a>
            <div className="ah-top-right">
              <div className="ah-search">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#777" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input type="text" placeholder="Search" />
              </div>
              <a href="tel:+919763729538" className="ah-contact-link">
                <img src={CallIcon} alt="Call" className="ah-contact-icon" />
                +91 9763729538
              </a>
              <a href="mailto:Info@Adorpower.Com" className="ah-contact-link">
                <img src={MailIcon} alt="Mail" className="ah-contact-icon" />
                info@adorpower.Com
              </a>
              <a href="/contact-us" className="ah-cta-btn">Contact Us</a>
              <button
                className="ah-hamburger"
                onClick={() => setMobileOpen((v) => !v)}
                aria-label="Toggle menu"
              >
                {mobileOpen ? (
                  <>
                    <span style={{ transform: "rotate(45deg) translate(5px, 5px)" }} />
                    <span style={{ opacity: 0, width: 0 }} />
                    <span style={{ transform: "rotate(-45deg) translate(5px, -5px)" }} />
                  </>
                ) : (
                  <><span /><span /><span /></>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* NAV BAR */}
        <div className="ah-nav-bar">
          <div className="ah-nav-inner">
            <ul className="ah-nav-links">
              {NAV_LINKS.map(({ label, path, dropdown }) => (
                <li
                  key={label}
                  className="ah-nav-item"
                  onMouseEnter={() => dropdown && setOpenDropdown(label)}
                  onMouseLeave={() => setOpenDropdown(null)}
                >
                  <a
                    href={path}
                    className={`ah-nav-link${isActive(path) ? " active" : ""}`}
                  >
                    {label}
                    {dropdown && <ChevronDown open={openDropdown === label} />}
                  </a>

                  {dropdown && openDropdown === label && DROPDOWNS[label] && (
                    <div className="ah-dropdown">
                      {DROPDOWNS[label].map((child) =>
                        child.children ? (
                          <div key={child.label} className="ah-dd-parent">
                            <div className="ah-dd-has-sub">
                              {child.label}
                              <ChevronDown />
                            </div>
                            <div className="ah-dd-sub">
                              {child.children.map((sub) => (
                                <a
                                  key={sub.path}
                                  href={sub.path}
                                  className={`ah-dd-sub-item${isActive(sub.path) ? " ah-dd-active" : ""}`}
                                >
                                  {sub.label}
                                </a>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <a
                            key={child.path}
                            href={child.path}
                            className={`ah-dropdown-item${isActive(child.path) ? " ah-dd-active" : ""}`}
                          >
                            {child.label}
                          </a>
                        )
                      )}
                    </div>
                  )}
                </li>
              ))}
            </ul>

            <div className="ah-social">
              <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ah-social-icon" aria-label="LinkedIn"  target="_blank">
                <img src={LinkedInIcon} alt="LinkedIn" />
              </a>
              <a href="https://www.youtube.com/@adorIndia" className="ah-social-icon" aria-label="YouTube"  target="_blank">
                <img src={YouTubeIcon} alt="YouTube" />
              </a>
              {/* Grid icon — opens popup on click */}
              <button
                className="ah-social-icon grid"
                aria-label="More sites"
                onClick={() => setGridOpen(true)}
              >
                <img src={GridIcon} alt="More" />
              </button>
            </div>
          </div>
        </div>

      </div>

      {/* MOBILE DRAWER */}
      <div className={`ah-drawer${mobileOpen ? " open" : ""}`}>
        <div className="ah-drawer-inner">

          {/* Header row: logo + Contact Us + × */}
          <div className="ah-drawer-header">
            <img src={AdorLogo} alt="Ador" className="ah-drawer-header-logo" />
            <div className="ah-drawer-header-right">
              <a href="/contact-us" className="ah-drawer-contact-btn" onClick={closeAll}>Contact Us</a>
              <button className="ah-drawer-close-btn" onClick={closeAll} aria-label="Close menu">×</button>
            </div>
          </div>

          {/* Ador expandable section */}
          <div>
            <button
              className="ah-drawer-row"
              onClick={() => setMobileExpanded((p) => (p === "Ador" ? null : "Ador"))}
            >
              Ador
              <svg
                className={`ah-drawer-chevron${mobileExpanded === "Ador" ? " open" : ""}`}
                width="16" height="16" viewBox="0 0 16 16" fill="none"
              >
                <path d="M4 6l4 4 4-4" stroke="#000000" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            {mobileExpanded === "Ador" && (
              <div className="ah-drawer-sub">
                {GRID_LINKS.map((item) => (
                  <a
                    key={item.path}
                    href={item.path}
                    className={`ah-drawer-sub-link${item.label === "Ador India" ? " ah-drawer-sub-link-active" : ""}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={closeAll}
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Nav links */}
          {NAV_LINKS.map(({ label, path, dropdown }) => {
            const isExpanded = mobileExpanded === label;
            if (dropdown && DROPDOWNS[label]) {
              return (
                <div key={label}>
                  <button
                    className="ah-drawer-row1"
                    onClick={() => setMobileExpanded((p) => (p === label ? null : label))}
                  >
                    {label}
                    <svg
                      className={`ah-drawer-chevron${isExpanded ? " open" : ""}`}
                      width="16" height="16" viewBox="0 0 16 16" fill="none"
                    >
                      <path d="M4 6l4 4 4-4" stroke="#000000" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  {isExpanded && (
                    <div className="ah-drawer-sub">
                      {DROPDOWNS[label].map((child) =>
                        child.children ? (
                          <div key={child.label}>
                            <div className="ah-drawer-sub-link ah-drawer-sub-parent">{child.label}</div>
                            {child.children.map((sub) => (
                              <a
                                key={sub.path}
                                href={sub.path}
                                className="ah-drawer-sub-link ah-drawer-sub-child"
                                onClick={closeAll}
                              >
                                {sub.label}
                              </a>
                            ))}
                          </div>
                        ) : (
                          <a
                            key={child.path}
                            href={child.path}
                            className="ah-drawer-sub-link"
                            onClick={closeAll}
                          >
                            {child.label}
                          </a>
                        )
                      )}
                    </div>
                  )}
                </div>
              );
            }
            return (
              <a
                key={label}
                href={path}
                className="ah-drawer-row1"
                style={{ borderBottom: "1px solid #f3f3f3" }}
                onClick={closeAll}
              >
                {label}
              </a>
            );
          })}

          {/* Bottom social icons */}
          <div className="ah-drawer-socials">
            <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ah-drawer-social-icon" aria-label="LinkedIn"  target="_blank">
              <img src={LinkedInIcon} alt="LinkedIn" />
            </a>
            <a href="https://www.youtube.com/@adorIndia" className="ah-drawer-social-icon" aria-label="YouTube"  target="_blank">
              <img src={YouTubeIcon} alt="YouTube" />
            </a>
          </div>

        </div>
      </div>

      {/* ══ GRID POPUP OVERLAY ══ */}
      <div className={`ah-grid-overlay${gridOpen ? " open" : ""}`}>

        <div className="ah-grid-links">
          {GRID_LINKS.map((item) => (
            <a
              key={item.path}
              href={item.path}
              className={`ah-grid-link${item.active ? " ah-grid-active" : ""}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setGridOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </div>

        <button className="ah-grid-close" onClick={() => setGridOpen(false)} aria-label="Close">
          ×
        </button>

      </div>
    </>
  );
}